// utils/subscription.ts
//
// Shared "does this user have an active subscription?" check, so the premium
// upsell appears and disappears consistently everywhere it is shown.

/**
 * True when the user has a subscription that is present, not expired, and not
 * past its end date. Mirrors the check the sidebar upgrade card uses.
 */
export const hasActiveSubscription = (user: unknown): boolean => {
  const u = user as
    | {
        subscriptionStatus?: string;
        subscriptionEndDate?: string;
        subscriptionId?: string;
      }
    | null
    | undefined;

  if (!u) return false;

  const status = u.subscriptionStatus;
  if (!status && !u.subscriptionId) return false;
  if (String(status).toLowerCase() === "expired") return false;

  if (u.subscriptionEndDate) {
    const end = new Date(u.subscriptionEndDate);
    if (!Number.isNaN(end.getTime()) && end.getTime() < Date.now()) {
      return false;
    }
  }

  return true;
};
